import { Link, useLocation } from 'react-router-dom'

function NotFound() {
  const { pathname } = useLocation()

  return (
    <div className="flex min-h-screen flex-col bg-canvas text-fg">

      {/* Top rule */}
      <div className="h-px w-full bg-fg" />

      <div className="flex flex-1 flex-col items-center justify-center px-8 py-24">

        {/* Eyebrow */}
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-fg-secondary">
          404 — Page Not Found
        </p>

        {/* Headline */}
        <h1 className="font-zodiak mt-5 max-w-lg text-center text-4xl font-bold leading-tight text-fg sm:text-5xl">
          This page does not exist.
        </h1>

        {/* Requested path */}
        <p className="mt-5 text-sm text-fg-secondary">
          No content was found at{' '}
          <code className="rounded bg-fill px-1.5 py-0.5 font-mono text-xs text-fg">
            {pathname}
          </code>
        </p>

        {/* Divider */}
        <div className="mt-10 w-16 border-t border-line" />

        {/* Navigation options */}
        <nav className="mt-10 flex items-center gap-8">
          <Link
            to="/wire"
            className="text-xs font-semibold uppercase tracking-[0.18em] text-fg transition-colors hover:text-fg-secondary"
          >
            Wire Home
          </Link>
          <span className="h-3 w-px bg-line" />
          <Link
            to="/admin"
            className="text-xs font-semibold uppercase tracking-[0.18em] text-fg transition-colors hover:text-fg-secondary"
          >
            Admin
          </Link>
        </nav>

      </div>

      {/* Bottom rule */}
      <div className="h-px w-full bg-line" />

    </div>
  )
}

export default NotFound
